// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"574":"CoseBilkentLayout","654":"HierarchicalLayout","774":"kg-components"}[chunkId] || chunkId) + "." + {"574":"5ae9e491","654":"f17fdc66","725":"85c4d219","774":"de80af6e"}[chunkId] + ".chunk.js";
};